import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import WorkerTabRow from './WorkerTabRow';
import Arrays from '../../../utils/Arrays';
import { PsTable } from '../../table/PsTable';

class WorkersTabTable extends React.Component {

    buildHeader() {
        let checkedAll = false;
        if ( this.props.data || this.props.data.length > 0 ) {
            const nonSelectedElements = this.props.data.filter(element => !Arrays.contains(this.props.selectedIds, element.id));
            checkedAll = nonSelectedElements.length === 0;
        }
        return WorkerTabRow.renderHead('WORKER_TAB_TABLE', this.props.showOutsource,
            this.props.selectedIds !== null ? {
                checked: checkedAll,
                onChecked: (checked) => this.props.actionSelectAll(this.props.data, checked),
                text: this.props.selectAllText,
            } : null);
    }

    render() {
        if ( !this.props.user || !this.props.user.roles || !this.props.user.roles[0] ) {
            return null;
        }
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.buildHeader()}>
                {
                    _.map(this.props.data, object =>
                        <WorkerTabRow
                            key={object.id}
                            worker={object}
                            selectedIds={this.props.selectedIds}
                            actionSelectItem={this.props.actionSelectItem}
                            selectText={this.props.selectText}
                            action={this.props.action}
                            actionText={this.props.actionText}
                            showOutsource={this.props.showOutsource}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

const mapStateToProps = state => {
    return ( {
        user: state.auth.user,
    } );
};

export default connect(mapStateToProps)(WorkersTabTable);

WorkersTabTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,

    selectedIds: PropTypes.array,
    actionSelectItem: PropTypes.func,
    actionSelectAll: PropTypes.func,
    selectText: PropTypes.string,
    selectAllText: PropTypes.string,
    action: PropTypes.any,
    showOutsource: PropTypes.bool,
};
WorkersTabTable.defaultProps = {
    selectedIds: null,
    showOutsource: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/workers/WorkersTabTable.jsx